module.exports = __webpack_public_path__ + "img/twitter-blue.52301918.png";